export default {
  SET_PAYMENTS(state, payload) {
    state.payments.payments = payload.results;
    state.payments.totalCount = payload.total;
    state.payments.limit = payload.limit;
    state.payments.totalPage = payload.totalPage;
  },
};
